/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */
import type {
    QueryClient,
    QueryKey,
    QueryObserverOptions,
    UseQueryResult,
} from '@tanstack/react-query'
import { queryOptions, useQuery } from '@tanstack/react-query'

import fetch from 'Common/utils/query/workRequestClient.ts'
import type {
    RequestConfig,
    ResponseConfig,
    ResponseErrorConfig,
} from 'Common/utils/query/workRequestClient.ts'

import type { GetV1FoepapersQueryResponse } from '../../types/GetV1Foepapers.ts'

export const getV1FoepapersQueryKey = () => [{ url: '/v1/FoePapers' }] as const

export type GetV1FoepapersQueryKey = ReturnType<typeof getV1FoepapersQueryKey>

/**
 * {@link /v1/FoePapers}
 */
export async function getV1Foepapers(
    config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
    const { client: request = fetch, ...requestConfig } = config

    const res = await request<GetV1FoepapersQueryResponse, ResponseErrorConfig<Error>, unknown>({
        method: 'GET',
        url: `/v1/FoePapers`,
        ...requestConfig,
    })
    return res
}

export function getV1FoepapersQueryOptions(
    config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
    const queryKey = getV1FoepapersQueryKey()
    return queryOptions<
        ResponseConfig<GetV1FoepapersQueryResponse>,
        ResponseErrorConfig<Error>,
        ResponseConfig<GetV1FoepapersQueryResponse>,
        typeof queryKey
    >({
        queryKey,
        queryFn: async ({ signal }) => {
            config.signal = signal
            return getV1Foepapers(config)
        },
    })
}

/**
 * {@link /v1/FoePapers}
 */
export function useGetV1Foepapers<
    TData = ResponseConfig<GetV1FoepapersQueryResponse>,
    TQueryData = ResponseConfig<GetV1FoepapersQueryResponse>,
    TQueryKey extends QueryKey = GetV1FoepapersQueryKey,
>(
    options: {
        query?: Partial<
            QueryObserverOptions<
                ResponseConfig<GetV1FoepapersQueryResponse>,
                ResponseErrorConfig<Error>,
                TData,
                TQueryData,
                TQueryKey
            >
        > & { client?: QueryClient }
        client?: Partial<RequestConfig> & { client?: typeof fetch }
    } = {},
) {
    const { query: queryConfig = {}, client: config = {} } = options ?? {}
    const { client: queryClient, ...queryOptions } = queryConfig
    const queryKey = queryOptions?.queryKey ?? getV1FoepapersQueryKey()

    const query = useQuery(
        {
            ...getV1FoepapersQueryOptions(config),
            queryKey,
            ...queryOptions,
        } as unknown as QueryObserverOptions,
        queryClient,
    ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

    query.queryKey = queryKey as TQueryKey

    return query
}
